




































































import { Component } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import { BusEvent } from '../models/bus';
import { bus } from '../bus';

import ProjectIcon from '@/components/icons/TopicsIcon.vue';
import ModulesIcon from '@/components/icons/ModulesIcon.vue';
import SkillsIcon from '@/components/icons/SkillsIcon.vue';
import TopicsIcon from '@/components/icons/TopicsIcon.vue';
import CategoriesIcon from '@/components/icons/CategoriesIcon.vue';
import ProgramsIcon from '@/components/icons/TopicsIcon.vue';

@Component({
  components: {
    'categories-icon': CategoriesIcon,
    'modules-icon': ModulesIcon,
    'project-icon': ProjectIcon,
    'course-icon': ProjectIcon,
    'skills-icon': SkillsIcon,
    'topics-icon': TopicsIcon,
    'programs-icon': ProgramsIcon
  }
})
export default class MainTabs extends CommonVue {
  public projectActive: boolean = false;
  public moduleActive: boolean = false;
  public skillActive: boolean = false;
  public topicActive: boolean = false;
  public categoryActive: boolean = false;
  public coursesActive: boolean = false;
  public programActive: boolean = false;

  public beforeMount() {
    bus.$on(BusEvent.PAGE_CHANGE, (path) => {
      this.updateTab(path);
    });
    this.updateTab(this.$router.currentRoute.name);
  }

  public updateTab(path: string) {
    const view = path.split('-')[0];
    this.skillActive = view === this.SKILL_SLUG;
    this.topicActive = view === this.TOPIC_SLUG;
    this.categoryActive = view === this.CATEGORY_SLUG;
    this.coursesActive = view === this.COURSES_SLUG;
    this.programActive = view === this.PROGRAM_SLUG;
    this.projectActive = view === this.PROJECT_SLUG;
    
    this.moduleActive = !(
      this.skillActive ||
      this.programActive ||
      this.topicActive ||
      this.categoryActive ||
      this.coursesActive ||
      this.projectActive
    );
  }
}
